module.exports = __webpack_public_path__ + "static/media/marker.d54bdac4.svg";